import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ShareSnsBtn = styled(Button)`
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background-color: #000;

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('48')};
    height: ${mixin.pxToVw('48')};
  }
`;

export const ShareSnsBtn2 = styled(Button)`
  width: 48px;
  height: 48px;
  border-radius: 100%;

  svg {
    width: 48px;
    height: 48px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('48')};
    height: ${mixin.pxToVw('48')};

    svg {
      width: ${mixin.pxToVw('48')};
      height: ${mixin.pxToVw('48')};
    }
  }
`;
